/** Ported from haulsheet index.html OCR helpers (OCR-START block). Do not invent. */
export const OCR_STATES = " AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY DC ";
export const OCR_EQUIP = {
    F: "Flatbed (F)",
    FLAT: "Flatbed (F)",
    FD: "Flatbed (FD)",
    SD: "Step deck (SD)",
    SDRG: "Step deck or RGN (SDRG)",
    FSD: "Flat or step deck (FSD)",
    SDL: "Step deck with loading ramps (SDL)",
    DD: "Double drop (DD)",
    RGN: "Removable gooseneck lowboy (RGN)",
    LB: "Lowboy (LB)",
    V: "Van (V)",
    R: "Reefer (R)",
    VR: "Van or reefer (VR)",
    FV: "Flatbed or van (FV)",
    FSDV: "Flat, step deck or van (FSDV)",
    HS: "Hotshot (HS)",
    PO: "Power only (PO)",
    CONG: "Conestoga (CONG)",
};
export function ocrIsState(t) {
    return (OCR_STATES.indexOf(" " + String(t || "").toUpperCase() + " ") >= 0 &&
        String(t).length === 2);
}
export function ocrLines(words) {
    if (!words.length)
        return [];
    const hs = words.map((w) => w.h).sort((a, b) => a - b);
    const tol = Math.max(6, hs[Math.floor(hs.length / 2)] * 0.6);
    const ws = words.slice().sort((a, b) => a.y + a.h / 2 - (b.y + b.h / 2));
    const out = [];
    let cur = null;
    for (const w of ws) {
        const cy = w.y + w.h / 2;
        if (!cur || Math.abs(cy - cur.cy) > tol) {
            cur = { cy, words: [], text: "" };
            out.push(cur);
        }
        cur.words.push(w);
        cur.cy += (cy - cur.cy) / cur.words.length;
    }
    for (const l of out) {
        l.words.sort((a, b) => a.x - b.x);
        l.text = l.words.map((w) => w.t).join(" ");
    }
    return out;
}
export function ocrNum(raw) {
    const t = String(raw || "")
        .trim()
        .replace(/^[^\d$]+/, "")
        .replace(/[|\]\)]+$/, "")
        .replace(/^\$/, "");
    return /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d+(\.\d+)?$/.test(t) ? t.replace(/,/g, "") : "";
}
export function ocrBlankLoad() {
    return {
        ref: "",
        origin: "",
        destination: "",
        pickup: "",
        delivery: "",
        pickupAt: "",
        deliverBy: "",
        equipment: "",
        weight: "",
        length: "",
        width: "",
        height: "",
        pieces: "",
        commodity: "",
        tarp: "",
        permits: "",
        linehaul: "",
        fsc: "",
        miles: "",
        deadhead: "",
        tolls: "",
        tarpFee: "",
        permitCost: "",
        other: "",
        diesel: "",
        dieselNote: "",
        route: "",
        hazards: [],
        stops: [],
        unreadable: [],
        notes: "",
    };
}
export function ocrCity(raw, label, load) {
    let t = String(raw || "")
        .replace(/^[^A-Za-z]+/, "")
        .replace(/[^A-Za-z.…]+$/, "")
        .trim();
    if (/\.{2,}|…/.test(t)) {
        t = t.replace(/[.…]+\s*$/, "").trim();
        load.unreadable.push(label + ' is cut off on the screen ("' + t + '...")');
    }
    return t.replace(/\s+/g, " ");
}
export function ocrBetterPlace(a, b) {
    a = String(a || "").trim();
    b = String(b || "").trim();
    if (!a)
        return b;
    if (!b)
        return a;
    const ac = a.split(",")[0].trim().toLowerCase();
    const bc = b.split(",")[0].trim().toLowerCase();
    if (ac === bc)
        return a.length >= b.length ? a : b;
    if (ac.indexOf(bc) === 0 && a.length > b.length)
        return a;
    if (bc.indexOf(ac) === 0 && b.length > a.length)
        return b;
    return a.length >= b.length ? a : b;
}
export function ocrPlacesFromRowText(rowText) {
    let places = [];
    let m;
    let re = /([A-Za-z][A-Za-z .'\-]{1,40}?)\s*,\s*([A-Z]{2})\b/g;
    while ((m = re.exec(String(rowText || "")))) {
        if (ocrIsState(m[2]))
            places.push(m[1].replace(/\s+/g, " ").trim() + ", " + m[2]);
    }
    if (places.length < 2) {
        places = [];
        re = /([A-Za-z][A-Za-z .'\-]{1,40}?)\s+([A-Z]{2})(?=\s|$)/g;
        while ((m = re.exec(String(rowText || "")))) {
            if (ocrIsState(m[2]) && !/^\d/.test(m[1]) && m[1].trim().length > 1) {
                places.push(m[1].replace(/\s+/g, " ").trim() + ", " + m[2]);
            }
        }
    }
    return places;
}
export function ocrClearFilledWarnings(L) {
    if (!L || !L.unreadable)
        return L;
    const drop = [];
    if (String(L.linehaul || "").trim()) {
        drop.push(/^Posted rate could not be read/i, /^Linehaul could not be read/i, /^Rate reads as/i, /^Rate is blank/i);
    }
    if (String(L.origin || "").trim())
        drop.push(/^Origin could not be read/i);
    if (String(L.destination || "").trim())
        drop.push(/^Destination could not be read/i);
    if (drop.length) {
        L.unreadable = L.unreadable.filter((u) => !drop.some((re) => re.test(u)));
    }
    return L;
}
export function ocrTitle(s) {
    return String(s || "")
        .toLowerCase()
        .replace(/\b[a-z]/g, (c) => c.toUpperCase());
}
/** Bennett screens write feet.inches: 8.06 = 8 ft 6 in */
export function ocrBennettDim(raw, label, load) {
    const m = String(raw || "").match(/^(\d+)\.(\d\d)$/);
    if (!m) {
        if (String(raw || "").trim())
            load.unreadable.push(label + ' reads as "' + raw + '"');
        return "";
    }
    const ft = +m[1];
    const inch = +m[2];
    if (inch >= 12) {
        load.unreadable.push(label + ' "' + raw + '" does not look like feet.inches');
        return raw + " ft";
    }
    return inch ? ft + " ft " + inch + " in" : ft + " ft";
}
/** Ported from index.html ocrWords: TSV level-5 rows, drop empty text and conf < 0. */
export function ocrWordsFromTsv(tsv) {
    const out = [];
    for (const line of String(tsv || "").split("\n")) {
        const c = line.split("\t");
        if (c.length < 12 || c[0] !== "5")
            continue;
        const text = c.slice(11).join(" ").trim();
        if (!text || parseFloat(c[10]) < 0)
            continue;
        out.push({ x: +c[6], y: +c[7], w: +c[8], h: +c[9], t: text });
    }
    return out;
}
/** Same drop rules as ocrWords when converting browser OcrWord[] intake. */
export function filterOcrWords(words) {
    const out = [];
    for (const w of words) {
        const text = String(w.text || "").trim();
        if (!text || w.conf < 0)
            continue;
        out.push({
            x: w.x0,
            y: w.y0,
            w: Math.max(0, w.x1 - w.x0),
            h: Math.max(1, w.y1 - w.y0),
            t: text,
        });
    }
    return out;
}
//# sourceMappingURL=shared.js.map